module.exports = __webpack_public_path__ + "media/images/athletes/1553-05a15d950f4e71fa43d4e2e628073214.png";